import { useState } from 'react';

const galleryImages = [
  {
    src: "https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/81a8aa8338a8d1cd3c331cc9a27481b4.jpeg",
    label: "개인 상담실"
  },
  {
    src: "https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/c7b39ede33a0702333b56147482d2b01.jpeg",
    label: "대기실"
  },
  {
    src: "https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/f7adf354061e06f347816b7fdfb07ccf.jpeg",
    label: "집단 상담실"
  }
];

export default function CenterIntro() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const goPrev = () => setLightboxIndex((prev) => (prev !== null ? (prev - 1 + galleryImages.length) % galleryImages.length : 0));
  const goNext = () => setLightboxIndex((prev) => (prev !== null ? (prev + 1) % galleryImages.length : 0));

  return (
    <section id="intro" className="py-16 bg-[#F5F7F4]">
      <div className="max-w-6xl mx-auto px-6">

        {/* 상단 타이틀 */}
        <div className="text-center mb-10">
          <div className="flex justify-center mb-3">
            <div className="w-10 h-0.5 bg-[#A8B5A0]"></div>
          </div>
          <h2 className="text-[26px] font-bold text-[#2C2C2C] mb-3">센터 소개</h2>
          <p className="text-[15px] text-[#A8B5A0] font-medium">
            마음의 회복과 성장을 돕는 전문 심리상담센터
          </p>
        </div>

        {/* 첫 번째 좌우 레이아웃 */}
        <div className="flex flex-col lg:flex-row items-center gap-10 mb-14">
          <div className="flex-1 space-y-4 text-[14px] text-[#4A4A4A] leading-relaxed">
            <h3 className="text-[18px] font-bold text-[#2C2C2C] mb-4">
              안전하고 따뜻한 상담 공간
            </h3>
            <p>
              우리 센터는 개인의 심리적 안정과 치유를 위해 전문적인 상담 서비스를 제공하는 심리상담 기관입니다.
            </p>
            <p>
              우리는 살면서 때때로 관계의 어려움, 감정의 혼란, 삶의 방향에 대한 문제를 겪게 됩니다.
            </p>
            <p>
              이러한 순간에 필요한 것은 아무에게도 방해 받지 않는 안전 공간입니다.
            </p>
            <p>
              우리 센터는 따뜻한 이해를 바탕으로 내담자가 자신의 감정과 삶을 이해하고 더 나은 방향으로 나아가도록 도움을 주고자 합니다.
            </p>
          </div>

          <div className="flex-1 w-full">
            <div className="w-full h-[320px] rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/aba6e16530b5b48ef296c519b5ae40c2.jpeg"
                alt="센터 내부 상담 공간"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* 두 번째 좌우 레이아웃 */}
        <div className="flex flex-col-reverse lg:flex-row items-center gap-10 mb-14">
          <div className="flex-1 w-full">
            <div className="w-full h-[280px] rounded-2xl overflow-hidden shadow-lg">
              <img
                src="https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/887095d0609c786589af3bc2557cda26.jpeg"
                alt="개인 상담실 내부"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1 space-y-4 text-[14px] text-[#4A4A4A] leading-relaxed">
            <h3 className="text-[18px] font-bold text-[#2C2C2C] mb-4">
              편안한 개인 상담실
            </h3>
            <p>
              각 상담실은 내담자가 상담할 때 자신의 이야기에 집중할 수 있도록 구성되어 있습니다.
            </p>
            <p>
              밝은 조명과 가구는 긴장을 풀고 마음을 열 수 있는 환경을 제공합니다.
            </p>
            <p>
              비밀이 철저히 보장되는 안전한 공간에서 당신의 이야기를 편안하게 나눌 수 있습니다.
            </p>
          </div>
        </div>

        {/* 하단 이미지 3장 갤러리 */}
        <div className="grid grid-cols-3 gap-4">
          {galleryImages.map((img, index) => (
            <div
              key={img.label}
              className="rounded-xl overflow-hidden shadow-md group cursor-pointer"
              onClick={() => openLightbox(index)}
            >
              <div className="w-full h-[170px] overflow-hidden relative">
                <img
                  src={img.src}
                  alt={img.label}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/80">
                    <i className="ri-zoom-in-line text-[#4A4A4A] text-base"></i>
                  </div>
                </div>
              </div>
              <div className="bg-white px-3 py-2 text-center">
                <p className="text-[12px] font-medium text-[#4A4A4A]">{img.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 인증 및 협력 기관 */}
        <div className="mt-14">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-3">
              <div className="w-10 h-0.5 bg-[#A8B5A0]"></div>
            </div>
            <h3 className="text-[18px] font-bold text-[#2C2C2C] mb-2">인증 및 협력 기관</h3>
            <p className="text-[13px] text-[#888888]">공인된 기관과의 협력을 통해 신뢰할 수 있는 서비스를 제공합니다.</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              {
                icon: 'ri-shield-check-line',
                color: 'bg-[#E8F5E9]',
                iconColor: 'text-[#4CAF50]',
                title: '우리 아이 심리바우처',
                desc: '서비스 제공 기관'
              },
              {
                icon: 'ri-mental-health-line',
                color: 'bg-[#FFF3E0]',
                iconColor: 'text-[#FF9800]',
                title: '정신건강심리상담 바우처',
                desc: '서비스 제공 기관'
              },
              {
                icon: 'ri-hand-heart-line',
                color: 'bg-[#FCE4EC]',
                iconColor: 'text-[#E91E63]',
                title: '평택시 아동보호',
                desc: '전문기관 협력 기관'
              },
              {
                icon: 'ri-graduation-cap-line',
                color: 'bg-[#E3F2FD]',
                iconColor: 'text-[#1976D2]',
                title: '2026 평택 교육지원청',
                desc: '공유학교 평택P-L.A.Y학교\n지역맞춤형 프로그램 제공 기관'
              }
            ].map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col items-center text-center"
              >
                <div className={`w-11 h-11 ${item.color} rounded-full flex items-center justify-center mb-3`}>
                  <i className={`${item.icon} text-xl ${item.iconColor}`}></i>
                </div>
                <p className="text-[13px] font-bold text-[#2C2C2C] leading-snug mb-1">{item.title}</p>
                <p className="text-[12px] text-[#888888] leading-snug whitespace-pre-line">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* 라이트박스 모달 */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center"
          onClick={closeLightbox}
        >
          <div
            className="relative max-w-3xl w-full mx-6"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-10 right-0 w-9 h-9 flex items-center justify-center text-white/80 hover:text-white transition-colors cursor-pointer"
              onClick={closeLightbox}
            >
              <i className="ri-close-line text-2xl"></i>
            </button>

            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={galleryImages[lightboxIndex].src}
                alt={galleryImages[lightboxIndex].label}
                className="w-full max-h-[65vh] object-cover object-top"
              />
              <div className="bg-white px-5 py-3 text-center">
                <p className="text-[14px] font-semibold text-[#2C2C2C]">{galleryImages[lightboxIndex].label}</p>
                <p className="text-[12px] text-[#A8B5A0] mt-1">{lightboxIndex + 1} / {galleryImages.length}</p>
              </div>
            </div>

            <button
              className="absolute left-[-52px] top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer"
              onClick={goPrev}
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>

            <button
              className="absolute right-[-52px] top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 text-white transition-colors cursor-pointer"
              onClick={goNext}
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
